(() => {
  const instances = new Map();
  function init(root) {
    if (instances.has(root) || root.dataset.ready || !window.Swiper) return;
    const mediaQuery = matchMedia('(prefers-reduced-motion: reduce)');
    let globallyPaused = mediaQuery.matches || root.dataset.autoplay !== 'true';
    let visible = false;
    const manuallyPaused = new Set();
    const manualPlay = new Set();
    const abort = new AbortController();
    const listen = (el, event, fn) => el.addEventListener(event, fn, {signal:abort.signal});
    const cards = () => [...root.querySelectorAll('.pp-reel-slide')];
    const tools = root.querySelector('[data-reels-pause]');
    const count = root.querySelector('[data-reel-count]');
    const syncTools = () => { tools.textContent = globallyPaused ? 'Videoları oynat' : 'Tümünü duraklat'; };
    // Like the archived source, repeat a <4-slide set for a seamless loop.
    // These are the same three clips, not additional people or reviews.
    const wrapper = root.querySelector('.swiper-wrapper');
    [...wrapper.children].forEach(slide => wrapper.appendChild(slide.cloneNode(true)));
    // Source coverflow geometry; scaled spacing fits this buy-box rather than a full-width section.
    let swiper;
    swiper = new Swiper(root.querySelector('.pp-reels-swiper'), {
      effect:'coverflow', grabCursor:true, centeredSlides:true, slidesPerView:'auto',
      initialSlide:1, spaceBetween:12, threshold:10, speed:mediaQuery.matches ? 0 : 300,
      coverflowEffect:{rotate:0,stretch:0,depth:100,modifier:1.5,slideShadows:true},
      loop:true, watchSlidesProgress:true,
      navigation:{prevEl:root.querySelector('.pp-reel-prev'),nextEl:root.querySelector('.pp-reel-next')},
      a11y:{prevSlideMessage:'Önceki video',nextSlideMessage:'Sonraki video'},
      on:{slideChange(){ requestAnimationFrame(update); },transitionEnd(){update();},resize(){requestAnimationFrame(update);}}
    });
    function update() {
      if (!swiper) return;
      const viewport = root.querySelector('.pp-reels-swiper').getBoundingClientRect();
      cards().forEach(slide => {
        const video = slide.querySelector('video');
        const rect = slide.getBoundingClientRect();
        const onscreen = Math.min(rect.right,viewport.right) - Math.max(rect.left,viewport.left) > rect.width * .4;
        const key = slide.dataset.reelIndex;
        const canPlay = visible && !document.hidden && onscreen && !manuallyPaused.has(key) && (!globallyPaused || manualPlay.has(slide));
        if (canPlay) { if(video.paused) video.play().catch(() => {}); }
        else video.pause();
        // Offscreen loop copies must not create invisible tab stops.
        slide.querySelectorAll('button').forEach(b => b.tabIndex = onscreen ? 0 : -1);
        slide.setAttribute('aria-hidden', String(!onscreen));
      });
      count.textContent = `${root.querySelector('.swiper-slide-active')?.dataset.reelIndex || 1} / 3`;
    }
    cards().forEach(slide => {
      const video = slide.querySelector('video');
      const title = slide.querySelector('figcaption span').textContent.trim();
      const toggle = slide.querySelector('.pp-reel-toggle');
      const sound = slide.querySelector('.pp-reel-sound');
      video.muted = true; video.playsInline = true; video.loop = true; video.controls = false;
      const sync = () => {
        slide.classList.toggle('is-playing', !video.paused);
        slide.classList.toggle('is-audible', !video.muted);
        toggle.setAttribute('aria-label', `${title}: ${video.paused ? 'oynat' : 'duraklat'}`);
        sound.setAttribute('aria-label', `${title}: sesi ${video.muted ? 'aç' : 'kapat'}`);
        sound.setAttribute('aria-pressed',String(!video.muted));
      };
      ['play','pause','volumechange'].forEach(e => listen(video,e,sync));
      const togglePlayback = () => {
        const key = slide.dataset.reelIndex;
        if (video.paused) { manuallyPaused.delete(key); manualPlay.add(slide); video.play().catch(() => {}); }
        else { manuallyPaused.add(key); manualPlay.delete(slide); video.pause(); }
      };
      listen(toggle,'click',togglePlayback);
      listen(video,'click',togglePlayback);
      listen(sound,'click',() => {
        const unmute = video.muted;
        cards().forEach(other => other.querySelector('video').muted = true);
        video.muted = !unmute;
      });
      sync();
    });
    listen(tools,'click',() => {
      globallyPaused = !globallyPaused;
      manualPlay.clear(); manuallyPaused.clear();
      syncTools(); update();
    });
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      update();
    }, {threshold:0.15});
    observer.observe(root.querySelector('.pp-reels-swiper'));
    listen(document,'visibilitychange',update);
    listen(mediaQuery,'change',() => {
      globallyPaused = mediaQuery.matches || root.dataset.autoplay !== 'true';
      manualPlay.clear(); swiper.params.speed = mediaQuery.matches ? 0 : 300; syncTools(); update();
    });
    root.dataset.ready = 'true'; syncTools();
    instances.set(root, () => {
      observer.disconnect();abort.abort();cards().forEach(s=>s.querySelector('video').pause());swiper.destroy();instances.delete(root);
    });
  }
  function boot(){document.querySelectorAll('[data-pp-lamp-reels]').forEach(init);}
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  window.addEventListener('load',boot,{once:true});
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:section:unload',event=>{
    instances.forEach((dispose,root)=>{if(event.target.contains(root))dispose();});
  });
})();
